module.exports = __webpack_public_path__ + "img/mOq.f24f79bb.png";